import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";


export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state: {
    recipes: [],
    lines: [],
    ingredients: [],
    resources: [],
    currentUser: null,
    currencies: [],

    linePrices: [], // doesn't use

    currencyCode: 'RUB',
    country: 'RU',
    lang: 'EN',

    currentLine: 'asm-100ka',
    currentRecipe: 'D000',
    capability: 0,
    period: 30,
    source: {}
  }
}
